import { Module } from 'vuex';
import { NewsletterState } from '@/store/modules/newsletter/types';
import { RootState } from '@/store/types';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const state: NewsletterState = {
    activeList: null,
    activeListGroups: [],
    activeListRecipients: [],
    activeGroupsRecipients: [],
    lists: [],
    mailupLogged: false,
};

const namespaced: boolean = true;

export const newsletter: Module<NewsletterState, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
};
